// extracted by mini-css-extract-plugin
module.exports = {"container":"journey-module--container--2QtC5","color":"journey-module--color--1Vqw-","left":"journey-module--left--1I7dj","right":"journey-module--right--MvoyT"};